module.exports = __webpack_public_path__ + "img/ex_2_a.0f92f48c.jpg";